/** Decodes HTML entities (e.g. &euro; → €) for rendering in React text nodes. */
export function decodeHtml(html: string): string {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

/** Builds the property detail URL preserving the current search context. */
export function buildPropertyUrl(id: string, searchParams: URLSearchParams): string {
  const sp = new URLSearchParams();
  sp.set('accoId', id);
  for (const key of ['ds', 'de', 'ad', 'ch', 'pt'] as const) {
    const v = searchParams.get(key);
    if (v) sp.set(key, v);
  }
  return `/property/${id}?${sp.toString()}`;
}
